import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {
    CancelStripeSubscription,
    CancelStripeSubscriptionVariables,
} from "./__graphql-types__/CancelStripeSubscription.ts";
import type {
    UserPurchases,
    UserPurchasesVariables,
} from "./__graphql-types__/UserPurchases.ts";

export const CANCEL_STRIPE_SUBSCRIPTION_MUTATION: GqlOperation<
    CancelStripeSubscription,
    CancelStripeSubscriptionVariables
> = gqlOp(gql`
    mutation CancelStripeSubscription($subscriptionId: String!) {
        cancelStripeSubscription(subscriptionId: $subscriptionId) {
            error {
                code
                debugMessage
            }
        }
    }
`);

export const USER_PURCHASES_QUERY: GqlOperation<
    UserPurchases,
    UserPurchasesVariables
> = gql`
    query UserPurchases($kaid: String, $isActive: Boolean) {
        userPurchases(kaid: $kaid, isActive: $isActive) {
            id
            kind
            isActive
            cancelAt
            endedAt
            cancelAtPeriodEnd
            expiresAt
            extId
            kaid
            extProductID
            extUpdatedAt
            extCustomerID
        }
    }
`;
